import { render } from "./Landing.vue?vue&type=template&id=33810a5a&scoped=true"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"

import "./Landing.vue?vue&type=style&index=0&id=33810a5a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-33810a5a"

export default script